export interface Category {
  name: string;
  url: string;
}

export const categories: Category[] = [
  { name: 'Schuhe', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies & Sweater', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jacken', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Hosen & Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Kopfbedeckung', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Unterwäsche', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Trikots', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessoires', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Taschen', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Gürtel', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Parfums', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Sonstiges', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];